module.exports = __webpack_public_path__ + "static/zach-c9144b9d38f7b20b3f822f8bbe53b3e1.jpg";